import { Core } from '../core/core';
import { StorageAdapter } from '../interfaces/storage-adapter.interface';

export interface StorageOptions {
    dbName: string;
    dbStore: string;
}

export async function installStorage(instance: StorageAdapter) {
    //
    // add instance
    Core.storage = instance;
    Core.storage.enabled = true;
}
